import { dropWhile } from 'lodash';
import { isBefore, isAfter } from 'date-fns';
import { CoachingSessionInstance } from 'coaching/components/CoachingHomeView/CoachingSessionsBySubjectContainer';

export function getFilteredListOfUpcomingInstances(upcomingInstances?: CoachingSessionInstance[]) {
  // drop upcoming instances until we hit one that is not cancelled
  // so that the first upcoming instance we show is always not cancelled
  return dropWhile(
    // then sort instances using `startDateTime`
    upcomingInstances?.sort((a, b) => {
      if (isBefore(a.startDateTime, b.startDateTime)) return -1;
      else if (isAfter(a.startDateTime, b.startDateTime)) return 1;
      return 0;
    }),
    i => i.isCancelled
  );
}
